<div>
    <h2 class="confirmation-title">
        {{ 'event_steps.step_publish.title' | translate}}
    </h2>
    <div class="step5">
        @if (linkedEvent()) {
        <div class="linked-event">
            <span class="linked-label">{{
                "event_steps.step_publish.linked_event_label" | translate
                }}</span>
            <span>{{streappEvent().title}}</span>
        </div>
        }
        @if (!linkedEvent()) {
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_details.titel_label" | translate }}:
            </div>
            <div class="col-10">{{ streappEvent().title }}</div>
        </div>
        }
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_details.description_label" | translate }}:
            </div>
            <div class="col-10">
                {{ streappEvent().description }}
            </div>
        </div>
        @if (!linkedEvent()) {
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_details.date_label" | translate }}:
            </div>
            <div class="col-10">
                {{ streappEvent().created | dateTimeToDescription }}
            </div>
        </div>
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_location.location_label" | translate }}:
            </div>
            <div class="col-10">
                {{ streappEvent().location }}
            </div>
        </div>
        }
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_publish.blur_label" | translate }}:
            </div>
            <div class="col-10">
                {{ streappEvent().privacyEnabled ? 'Ja' : 'Nee' }}
            </div>
        </div>
        @if (streappEvent().highImpactEvent || eventFormStore.isHighImpactEvent()) {
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_privacy.heftigEvent_header" | translate }}:
            </div>
            <div class="col-10">
                {{ streappEvent().highImpactEvent ? 'Ja' : 'Nee' }}
            </div>
        </div>
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_privacy.hulpdiensten_header" | translate }}:
            </div>
            <div class="col-10">
                {{ streappEvent().emergencyServicesPresent ? 'Ja' : 'Nee' }}
            </div>
        </div>
        }
        <!-- Gekozen content -->
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_details.selected_file" | translate }}:
            </div>
            <div class="col-12">
                <!-- File preview -->
                <div class="files-selected-summary">
                    <div class="summary-preview-holder">
                        @for (item of streappEvent().preUploadedMediaItems; track item) {
                        <div class="preview">
                            <img class="preview-image-holder" [src]="item.previewFile"
                                onerror="this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"
                                alt="uploaded-image" />
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <!-- Shop content -->
        @if (authService.isStreapper && eventFormStore.preUploadedShopMediaItems().length > 0) {
        <div class="row">
            <div class="col-2 label">
                {{ "event_steps.step_details.selected_file_shop_only" | translate }}:
            </div>
            <div class="col-12">
                <div class="files-selected-summary">
                    <div class="summary-preview-holder">
                        @for (item of eventFormStore.preUploadedShopMediaItems(); track item; let i = $index) {
                        <div class="preview">
                            <img class="preview-image-holder" [src]="item.previewFile"
                                onerror="this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='"
                                alt="uploaded-image" />
                            @if (item.progress && !item.finished) {
                            <mat-spinner [diameter]="25" [mode]="'determinate'" [value]="item.progress">
                            </mat-spinner>
                            }
                            @if (item.hasError) {
                            <mat-icon class="error">
                                report_problem
                            </mat-icon>
                            }
                            @if (item.finished) {
                            <mat-icon>
                                check_circle_outline
                            </mat-icon>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
        <div class="button-actions">
            @if (eventFormStore.isLoading()) {
            <span class="publishing-text">
                <mat-progress-spinner class="loading-spinner" [diameter]="30"
                    mode="indeterminate"></mat-progress-spinner>
                <span>{{ "event_steps.step_publish.uploading" | translate }}
                    {{ eventFormStore.progress() }}
                </span>
            </span>
            }
        </div>
    </div>
</div>